import Link from "next/link";

import SectionShell from "components/Section-Shell";
import { getAllUseCases, UseCase } from "lib/prismic/use-cases";

const UseCaseComponent = ({ useCase }: { useCase: UseCase }) => {
  const { title, image, excerpt } = useCase.data;
  return (
    <div className="w-full ">
      <div className="h-full pt-4 pb-8 rounded-xl shadow-lg">
        <Link href={`/use-cases/${useCase.uid}`} passHref>
          <a>
            {image?.url && (
              <img
                className="mb-4 h-48 w-full object-center object-contain"
                src={image?.url}
                alt={title[0].text}
              />
            )}
            <div className="px-6 text-gray-900">
              <h3 className="text-xl my-3 font-heading text-center font-bold">
                {title[0].text}
              </h3>
              <p className="text-gray-700">{excerpt[0].text}</p>
            </div>
          </a>
        </Link>
      </div>
    </div>
  );
};

const Index = ({ blogs }: { blogs: UseCase[] }) => {
  return (
    <SectionShell
      heading="How You Can Use Daisho"
      subtitle="Use Cases: What, When, How."
      id="use-cases"
    >
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {blogs.map((useCase) => (
          <UseCaseComponent key={useCase.uid} useCase={useCase} />
        ))}
      </div>
    </SectionShell>
  );
};

export default Index;

export async function getStaticProps({ preview = false, previewData }) {
  const blogs = await getAllUseCases(previewData);
  return {
    props: { preview, blogs: blogs },
  };
}
